import { createContext } from 'react'

export const ChangeThresholdReviewContext = createContext<{ newThreshold?: number }>({})
